import script from "./AutoCreateAccounts.vue?vue&type=script&lang=ts&setup=true"
export * from "./AutoCreateAccounts.vue?vue&type=script&lang=ts&setup=true"

import "./AutoCreateAccounts.vue?vue&type=style&index=0&id=22be7d82&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22be7d82"]])

export default __exports__